module.exports = __webpack_public_path__ + "img/fight_card.ca1807ea.jpg";